import { InputMascara } from "app/components/inputs/InputMascara"
import { DataFormatoPT } from "app/types/DataFormatoPT"
import { IdentificadorItem } from "app/types/IdentificadorItem"
import globalMU from "globalMU"
import React, { useState } from "react"
import Calendar from "react-calendar"
import { ChaveAgrupamento } from "./ChaveAgrupamento"
import { DataCapacidadeDeCarga } from "./DataCapacidadeDeCarga"
import { LegendaDisponibilidadeCapacidadeDeCarga } from "./LegendaDisponibilidadeCapacidadeDeCarga"
const estilos = require('./disponibilidade-capacidade-de-carga.module.scss').default
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
import { format , isBefore } from "date-fns"

export type DisponibilidadeCapacidadeCargaPorItensAgrupadosProps = {
    dadosItensAgrupados: {
        chaveAgrupamento: ChaveAgrupamento
        identificadoresItens: IdentificadorItem[]
        datas: DataCapacidadeDeCarga[]
    }

    onNovaDataSelecionada: (novaData:DataFormatoPT) => void
    onAtualizarCalendario: (dataReferencia:Date) => void
}

export const DisponibilidadeCapacidadeCargaPorItensAgrupados = (props: DisponibilidadeCapacidadeCargaPorItensAgrupadosProps) => {
    const [novaDataPrevista, setNovaDataPrevista]  = useState<DataFormatoPT>("")


    const calendario = <div className="_mt-8 _mb-8 _max-w-md">
        <Calendar
            locale="pt-BR"
            showNeighboringMonth={false}
            tileClassName={({date,view}) => {
                
                if (isBefore(date, new Date())) {
                    return ['no-global-button',null]
                }

                const situacoes = props.dadosItensAgrupados.datas.filter(d => d.data == globalMU.converterDataFormatoENParaPT(format(date, "yyyy-MM-dd"))).map(d => d.situacao)
                
                // `situacoes == []` comparava dois arrays por REFERÊNCIA: era sempre false e nunca
                // teve efeito (TS2839, acusado a partir do TypeScript 5). Removido preservando o
                // comportamento atual — com a lista vazia o `every` abaixo devolve true e a data
                // segue sendo pintada como dataDisponivel, exatamente como hoje. Se a intenção
                // original era não pintar nada sem situação, é bug ANTIGO: tratar em ficha própria.
                const classeParaSituacao =
                        situacoes.every(s => s == "DISPONIVEL") ? estilos.dataDisponivel :
                        situacoes.some(s => s == "INDISPONIVEL") ? estilos.dataIndisponivel :
                        situacoes.every(s => s == "SEM_CADASTRO") ? estilos.dataSemCadastro : null
                        

                return ['no-global-button',classeParaSituacao]

                

            }}
            onClickDay={date => {
                const novaDataPrevista_ = format(date, "dd/MM/yyyy")
                setNovaDataPrevista(novaDataPrevista_)
                props.onNovaDataSelecionada(novaDataPrevista_)
            }}
            onActiveStartDateChange={({ action, activeStartDate, value, view }) => {
                props.onAtualizarCalendario(activeStartDate)
            }}
            />
    </div>

    const novaDataPrevistaInput = <div className={estiloFormulario.formulario}>
        <label>Nova Data Prevista</label>
        <InputMascara
            valor={novaDataPrevista}
            mascara="99/99/9999"
            onValorModificado={setNovaDataPrevista}

        />
    </div>
    
    return <>
        <div className={estilos.container}
            id="DisponibilidadeCapacidadeCargaPorItensAgrupados_Calendario">
            <div className={estilos.containerTitulo} >
                <span className={estilos.titulo}>
                    Consulta Disponibilidade Capacidade de Carga - Filial {props.dadosItensAgrupados.chaveAgrupamento.codigoFilial} / Data prevista {props.dadosItensAgrupados.chaveAgrupamento.dataPrevista}
                </span>
            </div>

            <div className={estilos.conteudo}>
                

                {calendario}

                {novaDataPrevistaInput}

                <LegendaDisponibilidadeCapacidadeDeCarga/>
                
            </div>
        </div>
    </>
}